const aiImages = {
  scopeOfAi: "https://markoknow.s3.ap-south-1.amazonaws.com/static/org/scopeofai.png",
  sectorsOfAi: "https://markoknow.s3.ap-south-1.amazonaws.com/static/org/sectorsofai.png",
  marketOfAi: "https://markoknow.s3.ap-south-1.amazonaws.com/static/org/marketofai.png",
  statsOfAi: "https://markoknow.s3.ap-south-1.amazonaws.com/static/org/statsofai.png",
  sectorsOfAi2: "https://markoknow.s3.ap-south-1.amazonaws.com/static/org/sectorsofai.png", // Note: The 5th URL provided was the same as the 2nd
  regionalNote: "https://markoknow.s3.ap-south-1.amazonaws.com/static/org/regionalnote.png",
};

export default aiImages;